<template>
  <div class="container-general-desp">
    <div class="despegarBannerOf-container">
      <div class="container-column-desp">
        <div>
          <img
            alt="Avion vectorial"
            class="plane-despegar"
            src="@/assets/img/banners/oferta/despegar/plane-despegar.svg"
          />
        </div>
        <div class="despegarBannerOf-text">
          <img
            alt="Logo bbva-despegar"
            class="despegar-bbva"
            src="@/assets/img/banners/oferta/despegar/bbva-despegar.svg"
          />
          <h2 class="despegarBannerOf-title">
            {{ title }}
          </h2>
          <p class="despegarBannerOf-subtitle">
            {{ subtitle }}
            <span class="despegarBannerOf-subtitle">
              {{ subtitle2 }}
            </span>
          </p>
        </div>
      </div>
      <img
        alt="Linea punteada vectorial"
        class="linea-desp-desk"
        src="@/assets/img/banners/oferta/despegar/linea-punteada-desp.svg"
      />
      <img
        alt="Linea punteada vectorial mobile"
        class="linea-desp-mobile"
        src="@/assets/img/banners/oferta/despegar/linea-punteada-desp-mob.svg"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerDespegarOferta",
  props: {
    title: String,
    subtitle: String,
    subtitle2: String
  }
};
</script>

<style scoped>
.container-general-desp {
  background-color: #004481;
  position: relative;
  margin-top: 94px;
}

.container-column-desp {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}

.despegarBannerOf-container {
  background-image: url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg"),
    url("../../../assets/img/1x/star_brillo.svg");
  background-position: left 51px top 78px, left 348px top 50px,
    right 551px top 111px, right 256px top 31px, left 51px top 339px,
    left 391px top 323px, right 353px bottom 52px, right 60px bottom 62px;
  background-size: 33px, 33px, 33px, 19px, 33px, 19px, 19px, 33px;
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
    no-repeat, no-repeat, no-repeat;
  width: 100%;
  max-width: 1280px;
  min-height: 407px;
  margin: auto;
  padding: 50px 30px;
}

img.despegar-bbva {
  max-width: 190px;
}

.plane-despegar {
  transform: translate(-50px, 30px);
  width: 280px;
}

.despegarBannerOf-text {
  color: #ffffff;
  width: 67.2%;
  display: flex;
  margin-left: auto;
  align-content: flex-end;
  justify-content: center;
  flex-direction: column;
  font-size: 24px;
}

.despegarBannerOf-title {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

.despegarBannerOf-title {
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 8px;
  margin-top: 20px;
}

.despegarBannerOf-subtitle {
  line-height: 32px;
  display: block;
}

.linea-desp-desk {
  width: 70%;
  max-width: 985px;
  margin: auto;
  display: flex;
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  opacity: 0;
}

.linea-desp-mobile {
  display: none;
}

.despegarBannerOf-subtitle {
  margin-top: 0px;
  margin-bottom: 0px;
}

@media (max-width: 1000px) and (min-width: 850px) {
  .despegarBannerOf-container {
    background-image: url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg");
    background-position: left 51px top 78px, left 348px top 50px,
      right 256px top 31px, left 51px top 339px, left 391px top 323px,
      right 353px bottom 52px, right 60px bottom 62px;
    background-size: 33px, 33px, 19px, 33px, 19px, 19px, 33px;
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
      no-repeat, no-repeat;
  }
}

@media (max-width: 850px) and (min-width: 600px) {
  .despegarBannerOf-title {
    font-size: 28px;
    line-height: 32px;
  }

  .despegarBannerOf-subtitle {
    font-size: 20px;
    line-height: 24px;
  }

  .plane-despegar {
    transform: translate(20px, 30px);
  }

  .despegarBannerOf-container {
    background-image: url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg");
    background-position: left 10px top 25px, right 0px top 0px,
      left 10px bottom 0px, right 10px bottom 30px, right 30px top 50px;
    background-size: 33px, 33px, 33px, 33px, 20px;
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
  }
}

@media (max-width: 600px) {
  /* Banner Despegar */
  .despegarBannerOf-title {
    font-size: 12px;
    line-height: 16px;
    margin-top: 6px;
    margin-bottom: 4px;
  }

  .despegarBannerOf-subtitle {
    font-size: 8px;
    line-height: 12px;
    display: inline;
  }

  .despegarBannerOf-container {
    background-image: url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg"),
      url("../../../assets/img/1x/star_brillo.svg");
    background-position: left 13px top 16px, left 75px top 27px,
      right 107.07px top 14px, right 30.07px top 29px, left 14px bottom 15px,
      left 104px bottom 10px, right 73.07px bottom 6px,
      right 17.07px bottom 52px;
    background-size: 11px, 11px, 11px, 11px, 11px, 11px, 11px, 11px;
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat,
      no-repeat, no-repeat, no-repeat;
  }

  img.despegar-bbva {
    max-width: 72.55px;
  }

  .plane-despegar {
    width: 75px;
    transform: translate(20px, 12px);
  }

  .container-general-desp {
    min-height: 148px;
    max-height: 148px;
    margin-top: 16px;
  }

  .linea-desp-desk {
    display: none;
  }

  .linea-desp-mobile {
    max-width: 985px;
    text-align: center;
    margin: auto;
    display: flex;
    position: absolute;
    bottom: 24px;
    left: 36px;
    right: 28px;
    width: 80%;
  }

  .despegarBannerOf-container {
    min-height: 148px;
    padding: 0;
  }

  .container-column-desp {
    flex-direction: row;
    padding-top: 27px;
  }

  .despegarBannerOf-text {
    width: auto;
    margin-right: 30px;
    margin-left: 30px;
  }
}
</style>
